import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';
function n(x){x=x||{};return Object.freeze({
 key:x.key||null,
 classification:x.classification||'NO_CHANGE',
 previousAlertAt:Number.isFinite(x.previousAlertAt)?x.previousAlertAt:null,
 now:Number.isFinite(x.now)?x.now:null,
 cooldownHours:Number.isFinite(x.cooldownHours)?Math.max(0,x.cooldownHours):24,
 priority:['CRITICAL','HIGH','MEDIUM','REVIEW','LOW','NONE'].includes(x.priority)?x.priority:'NONE',
 scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH'
});}
function elapsedHours(x){const a=n(x);if(a.previousAlertAt===null||a.now===null)return null;return Math.max(0,(a.now-a.previousAlertAt)/3600000);}
function suppress(input){
 const x=n(input), e=elapsedHours(x);
 if(x.classification==='NO_CHANGE'||x.classification==='MINOR_CHANGE') return true;
 if(x.priority==='CRITICAL'&&x.scope==='OWNED') return false;
 if(e===null) return false;
 return e<x.cooldownHours;
}
function decision(input){
 const x=n(input), s=suppress(x);
 return Object.freeze({
   key:x.key,
   state:s?'SUPPRESSED':'EMIT',
   reason:s?(x.classification==='NO_CHANGE'||x.classification==='MINOR_CHANGE'?'NOT_MEANINGFUL':'COOLDOWN'):'MEANINGFUL_OR_CRITICAL',
   tradeSignal:false
 });
}
function batch(items){
 const rows=Array.isArray(items)?items:[];
 const r=rows.map(decision);
 return Object.freeze({emit:Object.freeze(r.filter(x=>x.state==='EMIT')),suppressed:Object.freeze(r.filter(x=>x.state==='SUPPRESSED')),tradeSignal:false});
}
function selfTest(){
 const t=[],ok=(a,b)=>t.push({name:a,pass:!!b});
 const now=100000000;
 ok('no change is suppressed',suppress({classification:'NO_CHANGE',now})===true);
 ok('minor change is suppressed',suppress({classification:'MINOR_CHANGE',now})===true);
 ok('first meaningful change emits',suppress({classification:'MEANINGFUL_CHANGE',now,previousAlertAt:null})===false);
 ok('recent repeated meaningful alert suppressed',suppress({classification:'MEANINGFUL_CHANGE',now,previousAlertAt:now-2*3600000,cooldownHours:24})===true);
 ok('old meaningful alert emits again',suppress({classification:'MEANINGFUL_CHANGE',now,previousAlertAt:now-30*3600000,cooldownHours:24})===false);
 ok('critical owned bypasses cooldown',suppress({classification:'MEANINGFUL_CHANGE',priority:'CRITICAL',scope:'OWNED',now,previousAlertAt:now-1000})===false);
 ok('decision explains suppression',decision({classification:'MINOR_CHANGE'}).reason==='NOT_MEANINGFUL');
 ok('decision remains non-trading',decision({classification:'MEANINGFUL_CHANGE'}).tradeSignal===false);
 const b=batch([{classification:'NO_CHANGE'},{classification:'MEANINGFUL_CHANGE'}]);
 ok('batch separates emit and suppressed',b.emit.length===1&&b.suppressed.length===1);
 ok('batch remains non-trading',b.tradeSignal===false);
 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,n,elapsedHours,suppress,decision,batch,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestAlertSuppressionEngine=Object.freeze(API);
})(engineContext);
